import { Toaster as Sonner } from "sonner";
import { useTheme } from "../../contexts/themeContext";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-stone-950 group-[.toaster]:border-stone-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-stone-500",
          actionButton:
            "group-[.toast]:bg-stone-900 group-[.toast]:text-stone-50",
          cancelButton:
            "group-[.toast]:bg-stone-100 group-[.toast]:text-stone-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
